import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import AddPhotoAlternateOutlinedIcon from '@material-ui/icons/AddPhotoAlternateOutlined';
import ImportExportOutlinedIcon from '@material-ui/icons/ImportExportOutlined';

import BannerService from '../../services/Banner';
import { errors } from '../../services/API';

import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import Title from '../../components/Title/Title';
import Table from '../../components/Table/Table';
import Toast from '../../components/Toast/Toast';
import { ButtonSuccess } from '../../components/Button/Button';
import {
  verifyPagingAndSorting,
  PAGE,
  SIZE,
  DESC,
  TOTAL_ELEMENTS,
  TOTAL_PAGES,
} from '../../components/Table/Utils';

import BannerFilter from '../../forms/Banner/BannerFilter';
import { ButtonAdd } from '../../forms/Buttons/ButtonsAdd';
import Dialog from '../../forms/Dialog/DialogRemove';

import AuthorizedFunction from '../../security/AuthorizedFunction';
import AuthorizedElement from '../../security/AuthorizedElement';
import {
  __BANNER_EDITAR,
  __BANNER_REMOVER,
  __BANNER_ADICIONAR,
} from '../../security/RoleConfiguration';

import { Layout } from '../../layouts/private/Private';
import DialogPosicoes from './DialogPosicoes';

import { verifyPersistence, removePagingAndSorting } from '../../helper/PaginationHelper';

import { patternBoolean } from '../../variables/Enums/Range';

export class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: PAGE,
      size: SIZE,
      totalElements: TOTAL_ELEMENTS,
      totalPages: TOTAL_PAGES,
      sort: [{ orderBy: 'ativo', order: DESC }],
      defaultOrderBy: 'ativo',
      banners: [],
      filtered: false,
      filters: [],
      loading: true,
    }

    this.state = verifyPersistence(this.state, this.props.location);
  }  

  // DECLARAÇÃO DE REFERÊNCIA DOS COMPONENTES
  setToast = t => this.Toast = t;
  setBannerFilter = f => this.BannerFilter = f;
  setDialog = f => this.Dialog = f;
  setDialogPosicoes = f => this.DialogPosicoes = f;

  // LABELS
  labelEditar = id => !this.disabledEditar(id) ? "Editar" : "Você não tem permissão para fazer isso";
  labelAdicionarNaPaginaInicial = id => !this.disabledAdicionarNaPaginaInicial(id) ? "Adicionar na Página Inicial" : this.possuiPosicao(id) ? "O Banner já tem Posição Definida" : "Você não tem permissão para fazer isso";
  labelApagar = id => !this.disabledApagar(id) ? "Apagar" : "Você não tem permissão para fazer isso";

  // DISABLES
  disabledEditar = id => !AuthorizedFunction([__BANNER_EDITAR]);
  disabledAdicionarNaPaginaInicial = id => AuthorizedFunction([__BANNER_EDITAR]) ? this.possuiPosicao(id) : !AuthorizedFunction([__BANNER_EDITAR]);
  disabledApagar = id => !AuthorizedFunction([__BANNER_REMOVER]);

  possuiPosicao = id => {
    const banner = this.state.banners.find(b => b.cdBanner === id);
    return banner.posicao ? true : false;
  }
  
  // EDIÇÃO
  handleEditClick = id => { 
    this.props.history.push({ 
      pathname: `/admin/banners/${id}/editar`,
      state: {
        history: {
          path: `/admin/banners`,
          state: this.state,
        }
      }
    })
  };

  // ADICIONAR NA PAGINA INICIAL
  handleAdicionarNaPaginaInicialClick = id => {
    BannerService.adicionarNoInicio(id)
      .then(res => {
        this.filterData(this.state.filters);
        this.Toast.setState({
          message: {
            message: "O Banner foi Adicionado a Página Inicial com Sucessso.",
            type: 'success',
            open: true
          }
        })
      })
      .catch(error => {
        const e = errors(error);
        this.Toast.setState({
          message: {
            message: e.message,
            type: e.type,
            open: true
          }
        })
      })  
  }

  // ABRIR MODAL DE CONFIRMAÇÃO DE REMOÇÃO
  openDialogRemove = id => {
    const banner = this.state.banners.find(banner => banner.cdBanner === id);
    this.Dialog.setState({ 
      dialog: { 
        open: true, 
        title: `Deseja Remover o banner ${banner.titulo} ?`,
        text: ``,
        id: id,
        loading: false,
      }
    });
  }
  
  // REMOÇÃO
  handleRemoveClick = id => {
    this.Dialog.loading();

    BannerService.remove(id)
      .then(res => {
        const newBanners = this.state.banners.filter(banner => banner.cdBanner !== id)

        this.setState({ 
          banners: [...newBanners],
        })

        this.Dialog.close();
        this.Toast.setState({
          message: {
            message: "O Banner foi Apagado com Sucesso.",
            type: 'success',
            open: true
          }
        })
        
        this.loadData();        
      })
      .catch(error => {
        const e = errors(error);        
        this.Dialog.close();
        this.Toast.setState({
          message: {
            message: e.message,
            type: e.type,
            open: true
          }
        })        
      })
  }

  // CARREGAR DADOS
  loadData = () => {
    let filters = verifyPagingAndSorting(this.state);

    this.setState({ 
      filters: [...filters], 
      filtered: true, 
      loading: true, 
    });

    BannerService.filters(filters)
      .then(res => {
        if (res.data.content) {
          this.setState({ 
            banners: [...res.data.content],
            page: res.data.number,
            size: res.data.size,
            totalElements: res.data.totalElements, 
            totalPages: res.data.totalPages,
            loading: false,
          });
        } else {
          this.setState({ 
            banners: [],
            page: PAGE,
            size: SIZE,
            totalElements: TOTAL_ELEMENTS,
            totalPages: TOTAL_PAGES,
            loading: false,
          });
        }
      })
      .catch(error => {
        const e = errors(error);
        this.Toast.setState({
          message: {
            message: e.message,
            type: e.type,
            open: true
          }
        })

        this.setState({ loading: false });
      })   
  }
  
  // FILTROS
  filterData = (filters, isActive = true) => this.setState({ filtered: isActive, filters: [...removePagingAndSorting(filters)] }, () => this.loadData());

  // PÁGINA
  handlePage = page => this.setState({ page: page }, () => this.filterData(this.state.filters));

  // LINHAS POR PÁGINA
  handleRowsPerPage = (size, page) => this.setState({ size: size, page: page }, () => this.filterData(this.state.filters));

  // ORDENAÇÃO
  handleSort = (orderBy, order) => {
    if (this.state.sort.find(s => s.orderBy === orderBy)) {
        let newSort = this.state.sort.filter(s => s.orderBy !== orderBy);
        newSort.splice(this.state.sort.indexOf(this.state.sort.find(s => s.orderBy === orderBy)), 0, { orderBy: orderBy, order: order })
        this.setState({...this.state, sort: [...newSort], filtered: true });
    } else {
        this.setState({ ...this.state, sort: [...this.state.sort.filter(s => s.orderBy !== orderBy), { orderBy: orderBy, order: order }], filtered: true });
    }
  }
  handleClearSort = (orderBy) => {
      this.setState({ ...this.state, filtered: true, sort: orderBy ? [...this.state.sort.filter(s => s.orderBy !== orderBy)] : [{ orderBy: this.state.defaultOrderBy, order: DESC }] });
  };

  // TOTAL DE PAGINAS
  handleTotalPages = () => this.state.totalPages;

  // TOTAL DE ELEMENTOS
  handleTotalElements = () => this.state.totalElements;

  // VERIFICAR PERSISTENCIA NO FORMULARIO DE FILTROS
  handleFilterPersistence = () => this.BannerFilter ? this.BannerFilter.state ? this.BannerFilter.handleFilterPersistence(this.state.filters) : null : null;

  // COMPONENT DID MOUNT
  componentDidMount() { this.loadData(); }

  render () {
    const pageName = 'Listagem de Banners';
    const links = [
      {
        path: null,
        name: 'Configurações'
      }
    ];
  
    const columns = [
      { label: '#', name: 'cdBanner', func: null, key: true, hidden: true, },
      { label: 'Posição', name: 'posicao', func: null, key: false },
      { label: 'Título', name: 'titulo', func: null, key: false },
      { label: 'Descricao', name: 'descricao', func: null, key: false },
      { label: 'Data Início de Exibição', name: 'dataInicio', func: null, key: false },
      { label: 'Data Fim de Exibição', name: 'dataFim', func: null, key: false },
      { label: 'Ativo?', name: 'ativo', func: patternBoolean, key: false },
    ];
    
    const actions = [
      { 
        name: this.labelEditar,
        func: this.handleEditClick,
        icon: <EditOutlinedIcon />,
        disabled: this.disabledEditar,
      },
      { 
        name: this.labelAdicionarNaPaginaInicial,
        func: this.handleAdicionarNaPaginaInicialClick,
        icon: <AddPhotoAlternateOutlinedIcon />,
        disabled: this.disabledAdicionarNaPaginaInicial,
      },
      { 
        name: this.labelApagar,
        func: this.openDialogRemove,
        icon: <DeleteOutlinedIcon />,
        disabled: this.disabledApagar,
        color: "secondary",
      },
    ];

    this.handleFilterPersistence();

    return (
      <Layout>
        <Toast parentRef={this.setToast} />
        <Grid container >
          <Grid item xs={12}>
            <Breadcrumbs links={links} active={pageName} />
          </Grid>
        </Grid>
        <Title>{pageName}</Title>

        <Grid container >
          <Grid item xs={12}>
            <BannerFilter 
              parentRef={this.setBannerFilter}
              handleFilterChange={this.filterData}
            />
            <AuthorizedElement roles={[__BANNER_ADICIONAR]}>
              <ButtonAdd
                to={{ 
                  pathname: '/admin/banners/adicionar',
                  state: {
                    history: {
                      path: `/admin/banners`,
                      state: this.state,
                    }
                  }
                }}
                title="Adicionar Banner"
              />
            </AuthorizedElement>
            <Table
              loading={this.state.loading}         
              columns={columns}
              tableData={this.state.banners}
              actions={actions}
              page={this.state.page}
              handlePage={this.handlePage}
              handleTotalPages={this.handleTotalPages}
              handleTotalElements={this.handleTotalElements}
              rowsPerPage={this.state.size}
              handleRowsPerPage={this.handleRowsPerPage}
              sort={this.state.sort}
              handleSort={this.handleSort}
              handleClearSort={this.handleClearSort}
            />
          </Grid>
          <AuthorizedElement roles={[__BANNER_ADICIONAR]}>
            <ButtonSuccess
              onClick={() => this.DialogPosicoes.open()}
              startIcon={<ImportExportOutlinedIcon />}
              style={{ margin: 4 }}
              name={"Editar Posições na Página Inicial"}
            />
          </AuthorizedElement>
        </Grid>
        
        <DialogPosicoes 
          parentRef={this.setDialogPosicoes} 
          loadData={this.loadData}
        />

        <Dialog 
          parentRef={this.setDialog}
          handleConfirm={this.handleRemoveClick}
        />
      </Layout>
    )
  }
}

export default withRouter(List);